var module = angular.module('octopusApp.library');

module.controller('FeedsIndexController', function($scope, busy, octopusRepository, octopusClient) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status)  {
    isLoading.promise(octopusRepository.ServerStatus.getBuiltInFeedStats(status).then(function(builtIn) {
      isLoading.promise(octopusRepository.Feeds.list().then(function(feeds)  {
        $scope.feeds = feeds;
        $scope.builtIn = {
          feedId: 'feeds-builtin',
          totalPackages: builtIn.TotalPackages,
          indexingStatus: builtIn.IndexingStatus,
          synchronizationStatus: builtIn.SynchronizationStatus,
          pushUrl: octopusClient.resolve(builtIn.Links["NuGetPush"])
        };
      }));
    }));
  }));
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/feeds/controllers/feeds_index_controller.js
// module id = 5552517655000293
// module chunks = 1